import { Component, OnInit } from '@angular/core';
import { TransportColoringThemeAdministrationAPIService } from '../../../api/transportvisualization/TransportColoringThemeAdministration.service';
import { TransportColoringRule, TransportColoringTheme } from '../../../api/transportvisualization/transportvisualization.model';
import { DataSetDefinitionConverterService, DetailLayout, DetailLayoutItemProvider, DialogService, PagedContentConfiguration, PagedContentType, TableColumnDefinition } from '@sdbn/common';
import { DataType } from '@sdbn/common-essential';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { TransportVisualizationRuleEditorComponent } from './transport-visualization-rule-editor/transport-visualization-rule-editor.component';

@Component({
  selector: 'yard-transport-visualization-administration',
  standalone: false,
  templateUrl: './transport-visualization-administration.component.html',
  styleUrl: './transport-visualization-administration.component.scss',
})
export class TransportVisualizationAdministrationComponent implements OnInit {

  data = new Array<TransportColoringTheme>();

  configuration = new PagedContentConfiguration({
    columns: [
      new TableColumnDefinition({
        dictionaryKey: 'key',
        type: DataType.STRING,
        identifier: 'key'
      }),
      new TableColumnDefinition({
        dictionaryKey: 'type',
        type: DataType.STRING,
        identifier: 'type'
      })
    ],
    itemDataAccessor: {
      getTitle: (item: any) => item['name'],
      getSubtitle: (item: any) => null,
      getIcon: (item: any) => null
    },
    desktopType: PagedContentType.SIDE_TAB_SINGLE,
    mobileType: PagedContentType.ICON_MENU_SINGLE
  });

  detailLayout = new DetailLayout({ "sequences": [{ "allowFolding": false, "showTitle": false, "blocks": [{ "showTitle": false, "columnCount": 1, "rowCount": 2, "columnWidths": [100], "cells": [{ "column": 1, "row": 1, "colSpan": 1, "rowSpan": 1, "fields": [{ "id": "name", "key": "name", "width": 100 }] }, { "column": 1, "row": 2, "colSpan": 1, "rowSpan": 1, "fields": [{ "id": "isDefault", "key": "isDefault", "width": 100 }] }] }] }] });
  detailLayoutItemProvider: DetailLayoutItemProvider;
  attributes = [{ "id": "a515051e-d57d-4201-9f9b-2369289127a1", "key": "isDefault", "type": "BOOLEAN", "precision1": null, "precision2": null, "enumId": null, "lookupId": null }, { "id": "a58e5995-d3ac-4c50-8b08-43d98f74737c", "key": "name", "type": "STRING", "precision1": 255, "precision2": null, "enumId": null, "lookupId": null }];

  currentSelectedTheme?: TransportColoringTheme = undefined;
  currentEditingRule?: TransportColoringRule = undefined;
  currentTheme?: TransportColoringTheme = undefined;

  isLoading = false;
  showDetails = true;

  constructor(
    private tctaService: TransportColoringThemeAdministrationAPIService,
    private dataSetDefinitionConverterService: DataSetDefinitionConverterService,
    private dialogService: DialogService
  ) {


  }

  ngOnInit(): void {

    this.detailLayoutItemProvider = this.dataSetDefinitionConverterService.createDetailLayoutItemProvider(this.attributes, 'common.processing.entity.process-step', false);

    this.loadData();
  }

  public onAddRequested($event: any) {
    this.currentTheme = new TransportColoringTheme();
  }

  public saveTheme(): void {
    if (this.currentTheme) {
      this.tctaService.save(this.currentTheme).subscribe(() => {
        this.loadData();
      });
    }
  }

  public cancelEditing(): void { }

  public onSelectionChanged(theme: any) {
    this.currentSelectedTheme = theme as TransportColoringTheme;
    this.tctaService.get(theme.id).subscribe(theme => {
      this.currentTheme = theme;
      theme.transportColoringRule.sort((a, b) => (a.index || 0) - (b.index || 0));
    });
  }

  public addRule(): void {
    if (this.currentTheme) {
      this.currentTheme.transportColoringRule.push(new TransportColoringRule({ name: 'rule - ' + (this.currentTheme.transportColoringRule.length + 1) }));
    }
  }

  public drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.currentTheme!.transportColoringRule, event.previousIndex, event.currentIndex);
    for (let i = 0; i < this.currentTheme!.transportColoringRule.length; i += 1) {
      this.currentTheme!.transportColoringRule[i].index = i;
    }
  }

  public onDeleteRule(rule: TransportColoringRule) {
    let index = this.currentTheme!.transportColoringRule.indexOf(rule);
    this.currentTheme!.transportColoringRule.splice(index, 1);
    for (let i = 0; i < this.currentTheme!.transportColoringRule.length; i += 1) {
      this.currentTheme!.transportColoringRule[i].index = i;
    }
  }

  public onEditRule(rule: TransportColoringRule) {
    this.currentEditingRule = rule;
    this.dialogService.openMaxHeight(TransportVisualizationRuleEditorComponent, new TransportColoringRule(rule)).afterClosed().subscribe(result => {
      if (result) {
        let rules = Object.assign(new Array<TransportColoringRule>(), this.currentTheme?.transportColoringRule);
        let index = rules.indexOf(this.currentEditingRule!);
        if (index > -1) {
          rules[index] = result as TransportColoringRule;
        }
        this.currentTheme!.transportColoringRule = rules;
      }
    });
  }

  private loadData() {
    this.isLoading = true;
    this.tctaService.getAll().subscribe(result => {
      this.data = result.values;
      this.isLoading = false;
    });
  }

  public switchDetailMode() {
    this.showDetails = !this.showDetails;
  }

}
